export default "__VITE_PUBLIC_ASSET__44427395__"